<template>
    <Layout class="bg-account">
        <Row type="flex" justify="center" align="middle" class="min-h-100vh py-5">
            <Col :xs="24" :md="22" :lg="20">
                <Card class="shadow">
                    <h1 class="text-20">{{ $t("model.user.type") }}</h1>
                    <Row align="middle">
                        <Col :xs="24">
                            <div class="d-flex">
                                <Card :bodyStyle="{ paddingLeft: '0px',paddingRight: '0px', textAlign: 'center'  }" class="shadow cursor-pointer ml-3 mr-3 card-item" @click="() => onClickRegisterType({ key: 'fisherman' })" style="backgroundColor:#7ec2f3; border-radius: 10px">
                                    <div><img :src="require(`../../../assets/icon/fisherman.svg`)" style="width: 150px;" /></div>
                                    <div class="mt-2"><span class="text-16 mt-5">{{ $t("views.register.registerFisherman") }}</span></div>
                                </Card>
                                <Card :bodyStyle="{ paddingLeft: '0px',paddingRight: '0px', textAlign: 'center' }"  class="shadow cursor-pointer ml-3 mr-3 card-item" @click="() => onClickRegisterType({ key: 'officer' })" style="backgroundColor:#a7e1c4;  border-radius: 10px">
                                     <div><img :src="require(`../../../assets/icon/manager.svg`)" style="width: 150px;" /></div>
                                    <div class="mt-2"><span class="text-16">{{ $t("views.register.registerOfficer") }}</span></div>
                                </Card>
                                <Card :bodyStyle="{ paddingLeft: '0px',paddingRight: '0px', textAlign: 'center'  }"  class="shadow cursor-pointer ml-3 mr-3 card-item" @click="() => onClickRegisterType({ key: 'people' })" style="backgroundColor:#ffbf00;  border-radius: 10px">
                                     <div><img :src="require(`../../../assets/icon/teamwork.svg`)" style="width: 150px;" /></div>
                                    <div class="mt-2"><span class="text-16 mt-5">{{ $t("views.register.registerPeople") }}</span></div>
                                </Card>
                            </div>
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>
    </Layout>
</template>

<script>
import { Card, Col, Layout, Row } from "ant-design-vue";
import { defineComponent, reactive } from "vue";
import { state as stateApp } from "../../../app.logic";
import { isLoading, onClickRegisterType } from "./register.logic";

export default defineComponent({
    components: {
        Card,
        Layout,
        Row,
        Col,
    },
    props: {
        menuContext: { default: () => stateApp.menuContext },
        viewOnly: { default: false }
    },
    setup(props) {
        const data = reactive({ rowProp: { gutter: 24 } });
        const refs = reactive({ form: null });
        return {
            props,
            data,
            refs,
            isLoading,
            onClickRegisterType
        };
    }
});
</script>

<style scoped>
.bg-account {
    background-image: url("../../../assets/bg/bg-account.jpg");
    background-size: 100% 100%;
}
.card-item {
    text-align: center;
    width: 100%;
}
</style>
